export default __webpack_public_path__ + "static/media/conab_video_parent.1d1656de.mp4";